/**
 * @file Reads the lang attribute from the html object to detect the language.
 */
const hyphenatedCurrentLocale = document.documentElement.lang || 'en'
const underscoredCurrentLocale = hyphenatedCurrentLocale.replace(/-/g, '_')
const lang = hyphenatedCurrentLocale.split('-')[0]
const tz = Intl.DateTimeFormat().resolvedOptions().timeZone

export { underscoredCurrentLocale, hyphenatedCurrentLocale, lang, tz }
